'use client';

import { Pagination } from 'react-bootstrap';
import { Icon } from '@iconify/react';
import React from 'react';
import './ItemPagination.css';

function ItemPagenation(prop) {
  const limit = 5;
  const totalPages = prop.total;
  let { current } = prop;

  // Calculate page range
  const pageRange = Math.min(limit, totalPages);
  let initial = Math.max(current - Math.floor(limit / 2), 1);
  let last = Math.min(initial + limit - 1, totalPages);

  if (last - initial + 1 < limit) {
    initial = Math.max(last - limit + 1, 1);
  }

  // Ensure 'More' ellipsis is correctly placed
  const showEllipsisLeft = initial > 1;
  const showEllipsisRight = last < totalPages;

  let items = [];

  // Previous Page Button
  if (current > 1) {
    items.push(
      <Pagination.Item
        key="prev"
        onClick={() => prop.onChangePage(current - 1)}
      >
        <Icon icon="akar-icons:chevron-left" />
      </Pagination.Item>
    );
  }

  // Ellipsis on the left
  if (showEllipsisLeft) {
    items.push(<Pagination.Ellipsis key="ellipsis-left" />);
  }

  // Page Numbers
  for (let page = initial; page <= last; page++) {
    items.push(
      <Pagination.Item
        key={page}
        active={page === current}
        onClick={() => prop.onChangePage(page)}
      >
        {page}
      </Pagination.Item>
    );
  }

  // Ellipsis on the right
  if (showEllipsisRight) {
    items.push(<Pagination.Ellipsis key="ellipsis-right" />);
  }

  // Next Page Button
  if (current < totalPages) {
    items.push(
      <Pagination.Item
        key="next"
        onClick={() => prop.onChangePage(current + 1)}
      >
        <Icon icon="akar-icons:chevron-right" />
      </Pagination.Item>
    );
  }

  return (
    <>
      <Pagination className="desktop" key="pagination-desktop">
        {items}
      </Pagination>
      <div className="PaginationMobileBtn">
        <Pagination className="mobile" key="pagination-mobile">
          {items}
        </Pagination>
      </div>
    </>
  );
}

export default ItemPagenation;



// 'use client'

// import {  Pagination } from "react-bootstrap";
// import { Icon } from "@iconify/react";
// import React from "react";
// import "./ItemPagination.css";

// function ItemPagenation(prop) {
//   let limit = 5;
//   let pageRange = limit;
//   if (prop.pageLimitIndex > 1) {
//     pageRange = limit * Number(prop.pageLimitIndex);
//   }

//   let items = [];
//   if (prop.current > 1) {
//     items.push(
//       <Pagination.Item
//         key={0}
//         onClick={() => prop.onChangePage(prop.current - 1)}
//       >
//         <Icon key="pLeft" icon="akar-icons:chevron-left" />
//       </Pagination.Item>
//     );
//   }
//   if (prop.current > pageRange) {
//     pageRange = prop.current + (limit - 1);
//   }

//   let initial = 1;
//   if (pageRange != limit) {
//     initial = pageRange - limit;
//   }

//   if (prop.current < initial && prop.current > 0) {
//     let i = limit - 1;
//     pageRange = prop.current - i;
//   }

//   for (let page = 0; page <= prop.total; page++) {
//     if (page >= initial && page <= pageRange) {
//       items.push(
//         <Pagination.Item
//           key={page}
//           data-page={page}
//           active={page == prop.current}
//           onClick={() => prop.onChangePage(page)}
//         >
//           {page}
//         </Pagination.Item>
//       );
//     }
//   }

//   items.push(<Pagination.Ellipsis key={prop.total} />);

//   if (prop.current < prop.total) {
//     items.push(
//       <Pagination.Item
//         key={prop.current + "item"}
//         onClick={() => prop.onChangePage(prop.current + 1)}
//       >
//         <Icon key="pRight" icon="akar-icons:chevron-right" />
//       </Pagination.Item>
//     );
//   }
//   return (
//     <>
//       <Pagination className="desktop" key="inventorypaged">
//         {items}
//       </Pagination>
//       <div className="PaginationMobileBtn">
      
//         <Pagination className="mobile" key="inventorypaged">
//           {items}
//         </Pagination>
//       </div>
//     </>
//   );
// }

// export default ItemPagenation;
